import React from 'react'
import type { SelectProps } from '@ztechapps/webui.input'
import { Select } from '@ztechapps/webui.input'
import { useUnitOfMeasureSelectOptions } from './useUnitOfMeasureSelectOptions'

export type UnitOfMeasureSelectProps = {
  category?: string
  filter?: Record<string, unknown>
} & Partial<SelectProps>

export const UnitOfMeasureSelect = ({ category, filter, ...rest }: UnitOfMeasureSelectProps) => {
  const options = useUnitOfMeasureSelectOptions({ category, filter })

  return (
    <Select
      placeholder="Select unit of measure"
      noOptionsMessage={() => 'No units of measure found'}
      options={options}
      isClearable={false}
      {...rest}
    />
  )
}
